import { useState } from 'react';
import { Drawer } from '@material-ui/core';

export default function useDrawer() {
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => setOpen(open => !open);

  return { isOpen: open, toggleDrawer, Drawer };
}